<template>
  <div class="top-news-detail-page">
    <div class="top-news-detail-page_container">
      <div class="top row">
        <div class="top-title">{{title}}</div>
        <div class="dateRange-filter row">
          <sn-tabs v-if="activeDateRange !== null" :active-tab-index="activeDateRange" :tabs="dateRangeTabs" @change="onDateRangeTabChange"></sn-tabs>
          <el-select v-if="market" class="select" @change="marketChange" v-model="market" placeholder="请选择">
            <el-option
              v-for="item in marketOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-if="emotional" class="select" v-model="emotional" @change="emotionalChange" placeholder="请选择">
            <el-option
              v-for="item in emotionalOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="news-detial" v-loading="isLoading">
        <sn-ranking
            class="top-news-item"
            :data="newsDetailData"
            :isShowIndex="true"
            :emitData="emitCompanyData"
            :sentiment="sentimentColor"
          >
          </sn-ranking>
        <div class="no-data-container" v-if="!isLoading && !newsDetailData.length">
          <no-data></no-data>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SnTabs from '@/components/common/SnTabs';
import NoData from '@/components/common/NoData';
import questionQuery from '@/rest/questionQuery';
import SnRanking from '@/components/common/SnRanking';

export default {
  data() {
    return {
      sentimentColor: 'neutral',
      rerender: true,
      isLoading: false,
      type: '',
      dateType: '',
      newsDetailData: [],
      dateRangeTabs: ['今天', '近一周'],
      dateRangeFilter: ['day', 'week'],
      count: 50,
      title: '',
      activeDateRange: null,
      selectedOptionTab: '',
      market: '',
      marketOptions: [
        {
          value: '全部公司',
          label: '全部公司'
        },
        {
          value: 'A股',
          label: 'A股'
        },
        {
          value: '港股',
          label: '港股'
        },
        {
          value: '美股',
          label: '美股'
        },
        {
          value: '发债企业',
          label: '发债企业'
        }
      ],
      emotional: '',
      emotionalOptions: [
        {
          value: 'total',
          label: '不限正负'
        },
        {
          value: 'positive',
          label: '正面'
        },
        {
          value: 'negative',
          label: '负面'
        }
      ]
    };
  },
  methods: {
    emotionalChange(res) {
      this.emotional = res;
      if (res === 'positive') {
        this.sentimentColor = 'positive';
      } else if (res === 'negative') {
        this.sentimentColor = 'negative';
      } else if (res === 'total') {
        this.sentimentColor = 'neutral';
      }
      this.getCompanyIndexRanking();
    },
    marketChange(res) {
      this.market = res;
      this.getCompanyIndexRanking();
    },
    onDateRangeTabChange(res) {
      if (res.item === '今天') {
        this.dateType = 'day';
      } else {
        this.dateType = 'week';
      }
      this.getIndustryRanking();
    },
    emitCompanyData(item) {
      if (this.$route.query.title === '热门公司排行') {
        this.$router.push({
          name: 'result-page', 
          query: {
            q: item.message
          }
        });
      }
    },
    getIndustryRanking() {
      this.isLoading = true;
      questionQuery.getIndustryRanking(this.selectedOptionTab, this.count, this.dateType).then(res => {
        this.isLoading = false;
        this.newsDetailData = res.map(item => {
          return {
            message: item.name,
            num: item.score
          };
        });    
      });
    },
    getCompanyIndexRanking() {
      this.isLoading = true;
      questionQuery.getCompanyIndexRanking(this.type, this.emotional, this.count, this.market).then(res => {
        this.isLoading = false;
        this.newsDetailData = res.map(item => {
          return {
            message: item.name,
            messageAlias: item.stockCode,
            num: item.score
          };
        });   
      });
    }
  },
  mounted() {
    this.title = this.$route.query.title;
    if (this.$route.query.title === '热门行业排行') {
      this.selectedOptionTab = 'industry';
      this.dateType = this.$route.query.dateType;
      this.activeDateRange = this.dateRangeFilter.indexOf(this.dateType);
      this.getIndustryRanking();
    } else if (this.$route.query.title === '热门公司排行') {
      this.type = this.$route.query.type;
      this.market = this.$route.query.market;
      this.emotional = this.$route.query.emotional;
      if (this.emotional === 'positive') {
        this.sentimentColor = 'positive';
      } else if (this.emotional === 'negative') {
        this.sentimentColor = 'negative';
      } else if (this.emotional === 'total') {
        this.sentimentColor = 'neutral';
      }
      this.getCompanyIndexRanking();
    }
  },
  components: {
    NoData,
    SnRanking,
    SnTabs
  }
};
</script>
<style lang="scss" scoped>
.top-news-detail-page{
  width: 100%;
  min-width: 1218px;
  min-height: 100%;
  background: #343239;
  &_container{    
    width: 720px;
    margin: 0 auto;
    padding: 24px 0;
    .top {
      width: 100%;
      align-items: center;
      justify-content: space-between;
      .top-title {
        font-size: 24px;
        color: #fff;
        font-weight: bold;
      }
    }
    .news-detial {
      // min-height: calc(100vh - 164px);
      margin-top: 16px;
      padding: 16px 0;
      background-color: #423f43;
      border-radius: 8px;
      .top-news-item {
        /deep/.ranking .body {
          // height: 2202px;
        }
        /deep/.ranking .body .bar-container {
          padding:10px 24px;
        }
        /deep/.ranking .body .bar-container .bar-header .category {
          color:#ffffff;
        }
      }
      .news-detail-by-row {
        height: 20px;
        margin: 8px 0;
        align-items: center;
        &.all-active {
          .first-item {
            color: #ffe624;
          }
          .second-item {
            color: #dad7ca;
          }
          .third-item {
            color: #b98f67;
          }
        }
        &.positive-active {
          .first-item {
            color: #fe4954;
          }
          .second-item {
            color: #ff7b83;
          }
          .third-item {
            color: #ffa9ae;
          }
        }
        &.negative-active {
          .first-item {
            color: #54ce96;
          }
          .second-item {
            color: #79d6ab;
          }
          .third-item {
            color: #b2edd2;
          }
        }
        .number {
          width: 16px;
          height: 16px;
          margin-right: 16px;
          font-size: 14px;
          font-weight: bold;
          text-align: left;
          color: #ffffff;
        }
        .company-name {
          width: 70px;
          font-size: 14px;
          color: #ffffff;
          margin-right: 16px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        .count {
          font-size: 12px;
          color: #ffffff;
          margin-left: 6px;
        }
      }
      .no-data-container {
        height: calc(100vh - 164px);
      }
    }
  }
}
.select {
  margin-left: 10px;
  width: 100px;
}
/deep/.el-select .el-input__inner {
  height: 26px;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  background-color: rgba(79, 78, 85, 1) !important;
}
/deep/.el-select .el-input__suffix {
  height: 48px !important;
  margin-top: -12px;
}
/deep/ .el-loading-mask{
  min-height: 600px;
}
</style>
